import { useTimer } from "pages/WorkModule/Projects/Project Timer/TimerContext"
import React, { useEffect, useMemo, useState } from "react"
import Spreadsheet from "react-spreadsheet"
import {
  fetchNodeData,
  FetchNodePostData,
  FetchPostData,
} from "./common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { showSkoteToast } from "./toastNotification"
import { Form, Label, Modal, Table } from "reactstrap"
import Loader from "pages/Separate/Loader"
import { Select, Tooltip } from "antd"
import AddTime from "../assets/images/AddTime.jpg"
import configure from "configure"
import moment from "moment"
import Swal from "sweetalert2"

const CustomDataViewer = ({ cell }) => {
  const { handleStartStop, isRunning, currentTaskId } = useTimer()
  const [ViewInfo, setViewInfo] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [timeList, setTimeList] = useState([])
  const [columnListId, setColumnListId] = useState("")
  const [allTimeList, setAllTimeList] = useState([])
  const [approveLink, setApproveLink] = useState("")
  const [remark, setRemark] = useState("")
  const [reportColumnId, setReportColumnId] = useState("")
  const [checkingActivity, setCheckingActivity] = useState(false)
  // const [activity, setActivity] = useState("")
  const [allTypeActivity, setAllTypeActivity] = useState(false)
  // const [reportProjectOption, setReportProjectOption] = useState([])
  const [selectedProject, setSelectedProject] = useState(null)
  const [selectedActivity, setSelectedActivity] = useState(null)
  const [rowsData, setRowsData] = useState([])

  const token = secureLocalStorage.getItem("auth_token")

  const [timeTaken, setTimeTaken] = useState({
    label: "00:30",
    value: "00:30",
  })

  /* ===============================
   1️⃣ Activity Header Data
================================ */
  const activity = {
    project_name: "Zithas ERP",
    name: "Daily Digital Activity",
    type: 1,
    project_id: 2,
    activity_id: 3,
    id: 27
  }

  const toggleLoading = load => {
    setLoading(load)
  }

  const handleCheckboxChange = rowId => {
    setRowsData(prev =>
      prev.map(row =>
        row.id === rowId ? { ...row, statusActivity: !row.statusActivity } : row
      )
    )
  }

  // const onGetDetails = async (id, obj) => {
  //   setActivityID(id)
  //   const outputString = obj?.project_name
  //     .split(" ")
  //     .map(word => word[0])
  //     .join("")
  //   setProjectName(outputString)
  //   getColumnsData(id, obj)
  // }

  // useEffect(() => {
  //   onGetDetails
  // }, [])

  // const getColumnsData = async (id, obj) => {
  //   const formEntries = {
  //     activity_id: obj?.activity_id,
  //     task_id: obj?.id,
  //     project_id: obj?.project_id,
  //   }
  //   const res = await FetchPostData(
  //     toggleLoading,
  //     `getActivityById`,
  //     secureLocalStorage.getItem('auth_token'),
  //     formEntries
  //   )
  //   if (res?.data?.success) {
  //     const activityData = res?.data?.data
  //     setCheckingButton(activityData?.activity_data?.checking_report)
  //     const result = activityData?.columns?.map(item => {
  //       const parsedColumns = JSON.parse(item?.columns)
  //       parsedColumns.id = item?.id
  //       parsedColumns.statusActivity = item?.status === 1
  //       parsedColumns.link = item?.link
  //       parsedColumns.remark = item?.remark
  //       return parsedColumns
  //     })
  //     setMainActivity(obj)
  //     setAllTimeList(activityData?.total_time)
  //     setActivityDetails(activityData)
  //     setAllActivity(true)
  //     const columns = activityData?.activity_data?.cloumns?.split(",") || []
  //     setActivityColumns(columns)
  //     const rows = new Array(Number(obj?.quantity)).fill(null).map(() => {
  //       return columns.reduce(
  //         (acc, col) => {
  //           acc[col] = ""
  //           return acc
  //         },
  //         {
  //           statusActivity: false,
  //         }
  //       )
  //     })
  //     if (activityData?.columns?.length != 0) {
  //       setRowsData(result)
  //       setColumnsIds(activityData?.columns?.map(obj => obj?.id)?.join(","))
  //     } else {
  //       if (columns?.length == 0) {
  //         setRowsData([])
  //       } else {
  //         setRowsData(rows)
  //       }
  //       setColumnsIds(null)
  //     }
  //   }
  // }

  const fetchTimerLogs = async id => {
    const response = await fetchNodeData(
      toggleLoading,
      `DigitalMTimeLogs/${id}`,
      secureLocalStorage.getItem("auth_token")
    )
    console.log(`response fetched: `, response)
    if (response.success) {
      console.log("inside response success")
      setTimeList(response.data)
    }
  }

  const getTiming = async id => {
    fetchTimerLogs(id)
    // setTimeList(allTimeList?.filter(obj => obj?.column_id == id))
    setViewInfo(true)
  }

  const [row, setRow] = useState(cell?.row)

  const onStartTimer = async (obj) => {
    const date = new Date()

    const formEntriesStart = {
      user_id: localStorage.getItem("auth_id"),
      column_id: obj?.id,
    }

    const formEntiesStop = {
      id: localStorage.getItem("timerId"),
    }

    const res = await FetchNodePostData(
      toggleLoading,
      isRunning ? "dmTimer/end" : "dmTimer/start",
      secureLocalStorage.getItem("auth_token"),
      isRunning ? formEntiesStop : formEntriesStart
    )
    console.log("obj", obj)
    // await addTime(null, 2, row?.id)

    if (res?.data?.status) {
      const taskId = obj.task_id
      if (!isRunning) {
        // Timer started
        localStorage.setItem("task_id", taskId)
        localStorage.setItem("timerId", res?.data?.data?.id)
        localStorage.setItem("start_time", date.toISOString())
        localStorage.setItem("DMtimer", true)

        handleStartStop(taskId)
      } else {
        // Timer stopped

        const startTime = localStorage.getItem("start_time")
        localStorage.removeItem("task_id")
        localStorage.removeItem("timerId")
        localStorage.removeItem("start_time")
        localStorage.removeItem("DMtimer")

        const timer_data = JSON.parse(
          localStorage.getItem("timer_data") || "{}"
        )

        const elapsedTime =
          timer_data.savedElapsed +
          Math.floor((new Date() - new Date(timer_data.startTime)) / 1000)

        timer_data.startTime = null
        timer_data.savedElapsed = elapsedTime

        localStorage.setItem("timer_data", JSON.stringify(timer_data))

        // Calculate total time
        const apiTime = res?.data?.data?.total_time
        let totalTime = apiTime || "00:00:00"

        if (!apiTime && startTime) {
          const diff = new Date() - new Date(startTime)
          const hours = Math.floor(diff / 1000 / 60 / 60)
          const minutes = Math.floor((diff / 1000 / 60) % 60)
          const seconds = Math.floor((diff / 1000) % 60)
          totalTime = `${String(hours).padStart(2, "0")}:${String(
            minutes
          ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
        }

        showSkoteToast(
          "<span class=>Digital Activity Timer Stopped</span>",
          totalTime,
          5000
        )

        handleStartStop(taskId)
      }
    } else {
      console.warn("Timer start/stop failed:", res?.data?.message)
    }
  }

  const addTime = async (e, type, id, statusChecked) => {
    if (e) e.preventDefault()


    if (timeTaken?.length != 0 || type != 1) {
      const formEntries = {
        column_id: type == 2 ? id : columnListId,
        activity_id: activity?.activity_id,
        task_id: activity?.id,
        project_id: activity?.project_id,
        user_id: localStorage.getItem("auth_id"),
        type: type,

      }
      const res = await FetchPostData(
        toggleLoading,
        "addDigitalActivityColumnsTimer",
        token,
        formEntries
      )
      console.log(
        "addDigitalActivityColumnsTimer: ",
        res
      )
      if (res?.data?.success) {
        setTimeTaken([])
        if (type == 1) {
          Swal.fire({
            icon: "success",
            text: "Time Added Successfully",
          })
        }
        setTimeList(res?.data?.data?.total_time)
        setAllTimeList(res?.data?.data?.all_total_time)

        if (statusChecked !== undefined) {
          setRow(prev => ({ ...prev, statusActivity: !statusChecked }))
        }

        // if (type == 2) {
        //   const userId = localStorage.getItem('auth_id')
        //   const res = await fetchData(noLoading, `getDigitalProjectTasks/${userId}/${getWeekStartAndEnd()?.startOfWeek}`, token);
        //   if (res?.success) {
        //     onChangeData(res?.data)
        //   }
        // }
      }
    } else {
      Swal.fire({
        icon: "warning",
        text: "Please Add Time",
      })
    }
  }

  const onAddApprove = async e => {
    e.preventDefault()
    const formEntries = {
      approve_link: approveLink,
      column_id: reportColumnId,
      remark: remark,
      user_id: localStorage.getItem("auth_id"),
    }
    const res = await FetchPostData(
      toggleLoading,
      "updateDigitalActivityColumnsLink",
      secureLocalStorage.getItem("auth_token"),
      formEntries
    )
    if (res?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Approved Link Added Successfully",
      }).then(() => {
        setRow(prev => ({ ...prev, link: approveLink, remark: remark }))
        setApproveLink("")
        setRemark("")
        // onApprovData(true)
        setCheckingActivity(false)
      })
    }
  }

  if (cell?.column === "Status") {
    return (
      <>
        {isLoading && <Loader />}
        <div
          onMouseDown={e => e.stopPropagation()}
          onClick={e => e.stopPropagation()}
          style={{
            display: "flex",
            gap: "6px",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <button
            title={
              isRunning && (currentTaskId === row.task_id)
                ? "Stop Timer"
                : "Start Timer"
            }
            className={`btn btn-sm me-1 
              ${isRunning && (currentTaskId === row.task_id)
                ? "btn-outline-danger"
                : "btn-outline-secondary"
              }`}
            onClick={() => {
              onStartTimer(row)
            }}
            type="button"
            // onClick={console.log("start Timer clicked !!!!")}
            disabled={
              isRunning &&
              localStorage.getItem("task_id") != row.task_id &&
              localStorage.getItem("timerId")
            }
          >
            <i className="bi bi-alarm-fill" />
          </button>

          <div className="text-center" id="customCheckbox">
            <input
              type="checkbox"
              className="form-check-input custom-checkbox mt-1 ms-1 me-2"
              checked={!!row?.statusActivity}
              onClick={e => {
                e.stopPropagation()

                if (!row?.id) {
                  console.warn("❌ row.id missing")
                  return
                }

                handleCheckboxChange(row.id)
                addTime(e, 2, row.id, e.target.checked)
              }}
            />
          </div>
          {
            row.isCheckingbuton &&
            <button
              className="btn btn-sm btn-outline-secondary custom_info_box3"
              title="Checking Report"
              onClick={() => {
                setReportColumnId(row?.id)
                setRemark(row?.remark)
                setApproveLink(row?.link)
                setCheckingActivity(true)
              }}
              disabled={row?.id == undefined || row?.id == ""}
              type="button"
            >
              <i className="fas fa-file-contract "></i>
            </button>
          }

          <div className="custom_info_box2">
            <button
              title="Time Logs"
              className="btn btn-sm btn-outline-secondary mb-1"
              onClick={() => {
                setColumnListId(row?.id)
                getTiming(row?.id)
              }}
              type="button"
              disabled={row?.id == undefined || row?.id == ""}
              style={{ marginLeft: "-7px" }}
            >
              <i className="bx bxs-calendar"></i>
            </button>
          </div>
        </div>

        <Modal
          isOpen={ViewInfo}
          toggle={() => {
            tog_center()
          }}
          centered
          size="lg"
          className="custom_checking_report_popup"
        >
          {isLoading && <Loader />}
          <div className="modal-header">
            <h5 className="modal-title mt-0">Time Taken</h5>
            <button
              type="button"
              onClick={() => {
                setViewInfo(false)
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <Form
              className="row d-flex justify-content-center align-items-center"
              onSubmit={e => addTime(e, 1)}
            >
              <div className="col-md-5 d-flex justify-content-end align-items-center ps-3">
                <div className="text-center">
                  <img src={AddTime} alt="Addepe" style={{ width: "100%" }} />
                </div>
              </div>

              <div className="col-md-7 d-flex flex-column justify-space-between  gap-5 mb-4">
                <div className="table-responsive col-md-12 time-taken-table">
                  <Table className="table table-bordered mb-0">
                    <thead
                      className="bg-white"
                      style={{ position: "sticky", top: 0 }}
                    >
                      <tr>
                        <th className="time_taken_sr">Sr. No</th>
                        <th className="time_taken_user">User</th>
                        <th className="time_taken_date">Date</th>
                        <th className="time_taken_timeCol">Time Taken</th>
                      </tr>
                    </thead>
                    <tbody>
                      {timeList?.map((obj, i) => {
                        return (
                          <tr key={i}>
                            <td className="text-center">{i + 1}</td>
                            <td className="text-center">
                              <Tooltip
                                color={"#752b97"}
                                title={obj?.alias_name}
                              >
                                <img
                                  src={`${configure.imgUrl}${obj?.avatar}`}
                                  className="img-fluid"
                                  style={{
                                    width: "25px",
                                    borderRadius: "100%",
                                  }}
                                />
                              </Tooltip>
                            </td>
                            <td className="text-center">
                              {moment(obj?.created_at).format("DD-MM-YYYY")}
                            </td>
                            <td className="text-center">{obj?.time}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                  {timeList?.length == 0 ? (
                    <p className="text-center text-purple fw-bold mt-3">
                      Timing is not added yet
                    </p>
                  ) : null}
                </div>
              </div>
            </Form>
          </div>
        </Modal>

        <Modal
          isOpen={checkingActivity}
          toggle={() => {
            setCheckingActivity(false)
          }}
          centered
          size="md"
          className=""
        >
          {isLoading && <Loader />}
          <div className="modal-header">
            <h5 className="modal-title mt-0">Checking Activity</h5>
            <button
              type="button"
              onClick={() => {
                setCheckingActivity(false)
              }}
              className="btn-modal-close"
            >
              <span aria-hidden="true" className="btn-modal-span">
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="d-flex flex-column new-task-modal mt-2">
                <div className="col-12  py-2 ">
                  <div className="col-12 d-flex flex-column justify-content-center align-items-start gap-3">
                    <div className="col-12 flex-column">
                      <Label>Approved Link</Label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Approved Link"
                        value={approveLink}
                        onChange={e => setApproveLink(e.target.value)}
                      ></input>
                    </div>
                    <div className="col-12 d-flex flex-column">
                      <Label>Remark</Label>
                      <textarea
                        cols="20"
                        rows="5"
                        className="form-control"
                        placeholder="Enter Remark"
                        value={remark}
                        onChange={e => setRemark(e.target.value)}
                      ></textarea>
                    </div>
                    <div className="d-flex flex-column">
                      <button
                        className="btn btn-success btn-label text-end"
                        type="button"
                        onClick={onAddApprove}
                      >
                        <i className="fas fa-check me-2 label-icon"></i>
                        Approved
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  return <span>{cell?.value}</span>
}

const ResizableTable2 = ({
  activityColumns,
  rowsData,
  onChangeExcelData,
}) => {
  const EXTRA_COLUMN = "Status"

  const columns = useMemo(
    () => {
      if (activityColumns.includes(EXTRA_COLUMN)) return activityColumns

      return [...activityColumns, EXTRA_COLUMN]
    },
    [activityColumns]
  )

  const spreadsheetData = useMemo(() => {
    return rowsData.map(row =>
      columns.map(col => ({
        value: row[col] ?? "",
        column: col,
        row, // 👈 attach row here
        readOnly: col === EXTRA_COLUMN,
      }))
    )
  }, [rowsData, columns])

  const onChange = matrix => {
    onChangeExcelData(matrix, columns, EXTRA_COLUMN)
  }

  return (
    <div style={{ minWidth: "150%", overflow: "auto" }}>
      <div style={{ width: "auto", padding: "12px", overflow: "auto" }}>
        <Spreadsheet
          data={spreadsheetData}
          columnLabels={columns}
          onChange={onChange}
          DataViewer={CustomDataViewer}
        />
      </div>
    </div>
  )
}

export default ResizableTable2
